module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADjSURBVHgB7di/CcJAGAXw79RSrSwEF3CC9IILOIRd3MABtBF3cAA3sHYDSe8QVokvcJAYYuPdJ5/m/eBxGg59XP6RiBARkXlFUYzEMhQcIxckQzYSoCe6Zj6lNKSsalHn3A3DubYpDV1ZVSi387s/i3EYqGJZLSyr5W/LDt78wBLDXPTdkQcy9d+3+O8+rr/H5kTX3ICJCYaTfNcEGfrPObJA2Wt9gvYt9BO5zwvXNhOrupLqHq1tLdWuL+2xmgexpOVkSsUaloyFJWNhyVh+pWRivmSp8bhss2Sd+RcQREQd8ATyo2jDmlZ61QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/larg/arrow-right.png
// module id = mtNO
// module chunks = 1